import { API, apiClient } from './api';

// ─── Author auth (separate token) ──────────────────────────
const AUTHOR_KEY = 'author_token';

export const authorLogin = async (email, password) => {
  const r = await apiClient.post('/author/login', { email, password }, {
    headers: { Authorization: '' },   // don't send admin token
  });
  if (r.data?.token) window.localStorage.setItem(AUTHOR_KEY, r.data.token);
  return r.data;
};

export const authorLogout = () => window.localStorage.removeItem(AUTHOR_KEY);

const withAuthor = (extra = {}) => ({
  ...extra,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem(AUTHOR_KEY) || ''}`,
    ...(extra.headers || {}),
  },
});

export const getAuthorMe = async () => (await apiClient.get('/author/me', withAuthor())).data;
export const updateAuthorMe = async (patch) => (await apiClient.patch('/author/me', patch, withAuthor())).data;
export const authorChangePassword = async (current_password, new_password) =>
  (await apiClient.post('/author/change-password', { current_password, new_password }, withAuthor())).data;

export const listAuthorPosts = async () => (await apiClient.get('/author/posts', withAuthor())).data;
export const createAuthorPost = async (p) => (await apiClient.post('/author/posts', p, withAuthor())).data;
export const updateAuthorPost = async (id, p) => (await apiClient.patch(`/author/posts/${id}`, p, withAuthor())).data;
export const deleteAuthorPost = async (id) => (await apiClient.delete(`/author/posts/${id}`, withAuthor())).data;

// ─── Admin: grant blog access to a person ──────────────────
export const grantBlogAccess = async (personId, email) =>
  (await apiClient.post(`/people/${personId}/grant-blog-access`, { email })).data;
export const revokeBlogAccess = async (personId) =>
  (await apiClient.post(`/people/${personId}/revoke-blog-access`)).data;

// ─── Author photo upload ───────────────────────────────────
export const uploadAuthorPhoto = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const r = await apiClient.post('/author/upload/photo', fd, withAuthor({
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
  return r.data;
};

// ─── Author comment moderation ─────────────────────────────
export const listAuthorComments = async (onlyPending = false) =>
  (await apiClient.get(`/author/comments?only_pending=${onlyPending ? 'true' : 'false'}`, withAuthor())).data;
export const approveComment = async (id, approved = true) =>
  (await apiClient.patch(`/author/comments/${id}`, { approved }, withAuthor())).data;
export const replyToComment = async (id, body) =>
  (await apiClient.post(`/author/comments/${id}/reply`, { body }, withAuthor())).data;
export const deleteComment = async (id) =>
  (await apiClient.delete(`/author/comments/${id}`, withAuthor())).data;

// ─── Public blog comments ──────────────────────────────────
export const listPublicComments = async (personSlug, postSlug) =>
  (await apiClient.get(`/people/${personSlug}/blog/${postSlug}/comments`)).data;
export const postPublicComment = async (personSlug, postSlug, payload) =>
  (await apiClient.post(`/people/${personSlug}/blog/${postSlug}/comments`, payload)).data;
